import { Link } from "react-router-dom";
import { ArrowUpRight, ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ product, testIdPrefix = "product" }) {
  const { add } = useCart();

  const quickAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    add(product, 1);
    toast.success(`${product.name} added to basket`);
  };

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`${testIdPrefix}-card-${product.id}`}
      className="group block"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#EFECE5]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
        />
        <div className="absolute top-4 left-4 overline text-[10px] bg-[#F9F8F6]/85 backdrop-blur px-3 py-1">
          {product.category.replace("-", " ")}
        </div>
        {product.mrp && product.mrp > product.price_from && (
          <div className="absolute top-4 right-4 overline text-[10px] bg-[#1B3B36] text-[#F9F8F6] px-3 py-1">
            {Math.round((1 - product.price_from / product.mrp) * 100)}% off
          </div>
        )}

        <button
          onClick={quickAdd}
          data-testid={`${testIdPrefix}-quick-add-${product.id}`}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-[#1B3B36] text-[#F9F8F6] px-5 py-3 text-[11px] tracking-[0.22em] uppercase inline-flex items-center gap-2 hover:bg-[#132A26]"
        >
          <ShoppingBag size={13} /> Add to basket
        </button>

        <div className="absolute bottom-0 left-0 right-0 p-5 flex justify-between items-end bg-gradient-to-t from-[#1B3B36]/55 via-transparent to-transparent">
          <div className="text-[#F9F8F6]">
            <div className="font-serif text-2xl leading-tight">{product.name}</div>
            <div className="text-[12px] tracking-wide mt-1 opacity-90">
              ₹{product.price_from.toLocaleString("en-IN")}
              {product.mrp && (
                <span className="line-through opacity-60 ml-2">
                  ₹{product.mrp.toLocaleString("en-IN")}
                </span>
              )}
            </div>
          </div>
          <div className="w-9 h-9 rounded-full bg-[#F9F8F6] text-[#1B3B36] flex items-center justify-center transition-transform group-hover:rotate-45">
            <ArrowUpRight size={16} />
          </div>
        </div>
      </div>
      <p className="mt-3 text-[13px] text-[#4A4A4A] font-light leading-relaxed max-w-[36ch]">
        {product.story}
      </p>
      <div className="mt-2 text-[11px] uppercase tracking-[0.2em] text-[#84968C]">
        View piece →
      </div>
    </Link>
  );
}
